import { render, staticRenderFns } from "./TendersDataTable.vue?vue&type=template&id=ec6f3ace"
import script from "./TendersDataTable.vue?vue&type=script&lang=js"
export * from "./TendersDataTable.vue?vue&type=script&lang=js"
import style0 from "./TendersDataTable.vue?vue&type=style&index=0&id=ec6f3ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports